"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetsResponseToJSON = exports.AssetsResponseFromJSONTyped = exports.AssetsResponseFromJSON = exports.instanceOfAssetsResponse = void 0;
var runtime_1 = require("../runtime");
var AssetResponse_1 = require("./AssetResponse");
var Paging_1 = require("./Paging");
/**
 * Check if a given object implements the AssetsResponse interface.
 */
function instanceOfAssetsResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAssetsResponse = instanceOfAssetsResponse;
function AssetsResponseFromJSON(json) {
    return AssetsResponseFromJSONTyped(json, false);
}
exports.AssetsResponseFromJSON = AssetsResponseFromJSON;
function AssetsResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'paging': !(0, runtime_1.exists)(json, 'paging') ? undefined : (0, Paging_1.PagingFromJSON)(json['paging']),
        'assets': !(0, runtime_1.exists)(json, 'assets') ? undefined : (json['assets'].map(AssetResponse_1.AssetResponseFromJSON)),
    };
}
exports.AssetsResponseFromJSONTyped = AssetsResponseFromJSONTyped;
function AssetsResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'paging': (0, Paging_1.PagingToJSON)(value.paging),
        'assets': value.assets === undefined ? undefined : (value.assets.map(AssetResponse_1.AssetResponseToJSON)),
    };
}
exports.AssetsResponseToJSON = AssetsResponseToJSON;
